import { render, staticRenderFns } from "./TraffbackWithMacros.vue?vue&type=template&id=50965dca"
import script from "./TraffbackWithMacros.vue?vue&type=script&lang=js"
export * from "./TraffbackWithMacros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports